module.exports = __webpack_public_path__ + "img/0-3.aceac30e.png";